<script context="module">
    let drawColor;
    let drawShadowColor;
    let drawStrokeColor;
</script>

<script>
    import { onMount, createEventDispatcher } from "svelte";
    import store from "../../store";
    import { _log } from "../../utils/logger";
    //import { Input } from "sveltestrap";

    let isFirstCall = true;
    export let id = "stroke";
    const dispatcher = createEventDispatcher();
    let pickr;
    let effectColor;
    let drawStrokeColorFrame;
    let color;
    let isActive = false;
    let isDrawShadow = false;

    const pickrOnInit = () => {
        pickr.setColor(getCurrentColor());
    };

    const pickrOnChange = (color, source, instance) => {
        const _color = color.toRGBA().toString();
        updateStore(_color);
        if (isFirstCall) {
            isFirstCall = false;
        } else {
            //dispatcher("onColorChange", { color: color.toRGBA(), id });
        }
        // pickr.applyColor(_color);
    };

    const pickrOnClear = (instance) => {
        _log('Event: "clear"', instance);
        updateStore("rgba(0, 0, 0, 0)");
    };

    function initCPicker() {
        pickr = Pickr.create({
            el: `.color-picker-${id}`,
            theme: "classic", // or 'monolith', or 'nano'

            swatches: [
                "rgba(244, 67, 54, 1)",
                "rgba(233, 30, 99, 0.95)",
                "rgba(156, 39, 176, 0.9)",
                "rgba(103, 58, 183, 0.85)",
                "rgba(63, 81, 181, 0.8)",
                "rgba(33, 150, 243, 0.75)",
                "rgba(3, 169, 244, 0.7)",
                "rgba(0, 188, 212, 0.7)",
                "rgba(0, 150, 136, 0.75)",
                "rgba(76, 175, 80, 0.8)",
                "rgba(139, 195, 74, 0.85)",
                "rgba(205, 220, 57, 0.9)",
                "rgba(255, 235, 59, 0.95)",
                "rgba(255, 193, 7, 1)",
            ],

            components: {
                // Main components
                preview: true,
                opacity: true,
                hue: true,

                // Input / output Options
                interaction: {
                    rgba: true,
                    hex: true,
                    hsla: true,
                    input: true,
                    clear: false,
                    // save: true,
                    // cancel: true,
                },
            },
        });
        pickr.on("init", pickrOnInit);
        pickr.on("change", pickrOnChange);
        pickr.on("clear", pickrOnClear);
    }

    function getCurrentColor() {
        let _color = color;
        if (id === "drawColor") {
            _color = drawColor;
        } else if (id === "drawStrokeColor") {
            _color = drawStrokeColor;
        } else if (id === "drawShadowColor") {
            _color = drawShadowColor;
        } else if (id === "drawTextColor") {
            _color = drawTextColor;
        } else if (id === "effectColor") {
            _color = effectColor;
        } else if (id === "frame") {
            _color = drawStrokeColorFrame;
        }
        return _color || "#333";
    }

    onMount(() => {
        initCPicker();

        const unsubscribe = store.subscribe((s) => {
            drawColor = s.drawColor;
            drawShadowColor = s.drawShadowColor;
            drawStrokeColor = s.drawStrokeColor;
            effectColor = s.effectColor;
            drawStrokeColorFrame = s.drawStrokeColorFrame;
            isDrawShadow =
                s.drawShadowBlur > 0 ||
                s.drawShadowX !== 0 ||
                s.drawShadowY !== 0;

            let _color = getCurrentColor();

            if (_color) {
                color = _color;
                pickr.applyColor(false);
                _log("CP", color);
                //pickr.setColor(color);
            }
            isActive =
                (id === "fill" && s.currentFill === "color") ||
                (id === "stroke" && s.currentStroke === "color") ||
                (id === "drawColor" && s.currentFill === "color") ||
                (id === "drawStrokeColor" && s.currentStroke === "color") ||
                (id === "drawShadowColor" &&
                    isDrawShadow &&
                    s.currentShadow === "color");
            _log("isActive", id, s.currentFill, s.currentStroke, isActive);
        });
        return () => {
            _log("Clear CP");
            unsubscribe();
            pickr.off("init", pickrOnInit);
            pickr.off("change", pickrOnChange);
            pickr.off("clear", pickrOnClear);
        };
    });

    function updateStore(color) {
        if (id === "drawColor") {
            store.setValues({
                currentFill: "color",
                drawColor: color,
                fillGradient: null,
                fillPattern: { src: "", name: "" },
            });
            window.fabricHelper.updateActive("color_fill");
        } else if (id === "drawShadowColor") {
            store.setValues({
                currentShadow: "color",
                drawShadowColor: color,
            });
            window.fabricHelper.updateActive("color_shadow");
        } else if (id === "frame") {
            store.setValues({
                drawStrokeColorFrame: color,
                strokeGradientFrame: null,
                strokePatternFrame: { src: "", name: "" },
            });
        } else if (id === "effectColor") {
            store.setValue("effectColor", color);
        } else if (id === "drawStrokeColor") {
            store.setValues({
                currentStroke: "color",
                drawStrokeColor: color,
                strokeGradient: null,
                strokePattern: { src: "", name: "" },
            });
            window.fabricHelper.updateActive("color_stroke");
        }
    }
</script>

<div class:activeColor={isActive}>
    <div class={`color-picker-${id}`} />
</div>
